import angular from 'angular';
import { MeurhBeneficiosTrocaFormController } from './troca.form.controller';

export class MeurhBeneficiosTrocaFormComponent implements angular.IComponentOptions {
    static selector = 'meurhBeneficiosTrocaFormComponent';
    static controller = MeurhBeneficiosTrocaFormController;
    static template = require('!!html-loader!./troca.form.html');
    static transclude = true;
    static bindings = {
        tipoBeneficio: '<',
        limitDate: '<?',
        entity: '=',
        form: '<?',
        editable: '<'
    };
}
